import { useEffect, useState } from "react";
import { GuestAccessModal, GuestAccessProps } from "./guest-access-modal/GuestAccessModal";
import { ButtonAnalyticsProvider, useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

interface GuestAccessShareItemProps extends GuestAccessProps {
    onClose: () => void;
}

/**
 * guest access closeable modal for media-page in share modal
 */
export const GuestShareItem = (props: GuestAccessShareItemProps) => {
    const { onClose, ...modalProps } = props;

    const [isOpen, setIsOpen] = useState(true);
    const sendButtonAnalytics = useButtonAnalytics();

    useEffect(() => {
        sendButtonAnalytics(
            "Manage Guest access",
            ButtonClickAnalyticsType.OPEN,
            props.entryId,
            "invitetomedia",
            "Media share modalbox"
        );
    }, []);

    const closeModal = () => {
        setIsOpen(false);
        onClose();
    };

    return (
        <ButtonAnalyticsProvider applicationFeature={"invitetomedia"} location={"Manage guest access modal"}>
            {isOpen && <GuestAccessModal {...modalProps} isOpen={isOpen} onClose={closeModal} />}
        </ButtonAnalyticsProvider>
    );
};
